import axios from 'axios';

const url = `${import.meta.env.VITE_FRESQRA_API}`;
const env = import.meta.env.VITE_ENV;

// Select API key based on environment
let apiKey;

switch (env) {
  case 'dev':
    apiKey = import.meta.env.VITE_API_KEY_DEV;
    break;
  case 'stage':
    apiKey = import.meta.env.VITE_API_KEY_STAGE;
    break;
  case 'prod':
    apiKey = import.meta.env.VITE_API_KEY;
    break;
  default:
    console.warn(`Unknown environment: ${env}`);
}

const axiosInstance = axios.create({
  baseURL: url,
  timeout: 5000,
});

axiosInstance.interceptors.request.use(async (config) => {
  config.headers['Content-Type'] = 'application/json';

  if (apiKey) {
    config.headers['Cplamd-Fresqra-Apikey'] = apiKey;
  }

  return config;
});

export default axiosInstance;
